export default __webpack_public_path__ + "60a182e2017f1d4539abc5fb59b3a894.svg";